// extracted by mini-css-extract-plugin
export default {"hide":"hide--rJG7tFc1ERUUD2t","pager":"pager--LLLHNoNmy3s9gq6","videoPlayer":"videoPlayer--wEWIF0uMOqzG13h"};